// Backup project (reference `backup`): GET /pbj/projects/:id/export saved
// as a .json file on the user's device. The file name follows the API's
// Content-Disposition (modules/pbjflow backupFileName).
import * as API from "../api";

/** "Backup_Paket_PBJ_Pengadaan_Laptop_2026-10-12.json". */
export function backupFileName(name: string, exportedAt: string): string {
  const slug = name
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^A-Za-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 60);
  return `Backup_Paket_PBJ_${slug || "project"}_${exportedAt.slice(0, 10)}.json`;
}

/** Fetches the backup and hands it to the browser as a download; throws what the API threw. */
export async function downloadPbjBackup(projectId: string): Promise<API.PbjExport> {
  const backup = await API.exportPbjProject(projectId);
  const blob = new Blob([JSON.stringify(backup, null, 2)], { type: "application/json;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = backupFileName(backup.project.name, backup.exportedAt);
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return backup;
}
